var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          { staticClass: "news-detail--template page-template bg-beige" },
          [
            _c("div", { staticClass: "relative container-fluid mw9 center" }, [
              _c("div", { staticClass: "row relative center pt5-ns z-5" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-7 ph0 pr4-ns w-100" },
                  [
                    _vm.post.post_type.is_video == true
                      ? _c(
                          "a",
                          { staticClass: "relative tc", attrs: { href: "#" } },
                          [
                            _vm.post.vimeo_video_id
                              ? _c("BgVimeoVideoEmbed", {
                                  staticClass: "mt4",
                                  attrs: {
                                    vimeoVideoId: _vm.post.vimeo_video_id,
                                  },
                                })
                              : _vm.post.featured_image != null
                              ? _c("img", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy",
                                      value: _vm.post.featured_image,
                                      expression: "post.featured_image",
                                    },
                                  ],
                                  staticClass: "dib w-100 relative",
                                })
                              : _c("img", {
                                  staticClass: "dib w-100 relative",
                                  attrs: { src: "'/uploads/refund.jpg'" },
                                }),
                          ],
                          1
                        )
                      : _c("span", [
                          _vm.post.featured_image != null
                            ? _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value: _vm.post.featured_image,
                                    expression: "post.featured_image",
                                  },
                                ],
                                staticClass: "dib w-100 relative",
                              })
                            : _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value: "/uploads/refund.jpg",
                                    expression: "'/uploads/refund.jpg'",
                                  },
                                ],
                                staticClass: "dib w-100 relative",
                              }),
                        ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-sm-5 relative" }, [
                  _vm.post.html_title && _vm.post.html_title != ""
                    ? _c("h1", {
                        staticClass:
                          "is-tablet-bold f30px ttn mt4 mt0-m mt0-l is-navy abs-center-ns",
                        domProps: { innerHTML: _vm._s(_vm.post.html_title) },
                      })
                    : _c(
                        "h1",
                        {
                          staticClass:
                            "is-tablet-bold f30px ttn mt4 mt0-m mt0-l is-navy abs-center-ns",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.post.title) +
                              "\n            "
                          ),
                        ]
                      ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "relative container-fluid mw9 center" }, [
              _c("div", { staticClass: "row top-sm relative center mb5 z-5" }, [
                _c(
                  "div",
                  { staticClass: "relative col-xs-12 col-sm-6 mt5-ns mb5 ph0" },
                  [
                    _c(
                      "span",
                      { staticClass: "f4 mb5 ttu is-tablet-cond-bold is-navy" },
                      [_vm._v(_vm._s(_vm._f("formatDate")(_vm.post.date)))]
                    ),
                    _vm._v(" "),
                    _vm.post.featured_text
                      ? _c("div", {
                          staticClass:
                            "db relative mt3 is-tablet-regular f5 b lh-title cms-content",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.marked(_vm.post.featured_text)
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "db relative mt3 is-tablet-regular f5 lh-title cms-content",
                      domProps: {
                        innerHTML: _vm._s(_vm.marked(_vm.post.content)),
                      },
                    }),
                    _vm._v(" "),
                    _vm.post.buttons
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "db relative mt3 is-tablet-regular f5 lh-title cms-content",
                          },
                          [
                            _vm.mobileOS === "Android"
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "db mw6 mt4 btn-generic has-red-bg",
                                    attrs: {
                                      href: "https://play.google.com/store/apps/details?id=com.livestyled.outsidelands",
                                      title: "App Link",
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("\n  APP STORE LINK\n  "),
                                    ]),
                                  ]
                                )
                              : _vm.mobileOS === "iOS"
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "db mw6 mt4 btn-generic has-red-bg",
                                    attrs: {
                                      href: "https://apps.apple.com/us/app/outside-lands/id547295030",
                                      title: "App Link",
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("\n  APP STORE LINK\n  "),
                                    ]),
                                  ]
                                )
                              : _vm.mobileOS === "other"
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "db mw6 mt4 btn-generic has-red-bg",
                                    attrs: {
                                      href: "https://apps.apple.com/us/app/outside-lands/id547295030",
                                      title: "App Link",
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v("\n  APP STORE LINK\n  "),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "relative col-xs-12 col-sm-6 mt7-ns ph0" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "dn flex-ns absolute bottom-0 left-0 right-0 center flex-row items-center quote-box",
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "f4 tc is-tablet-regular is-beige" },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm._f("truncate")(
                                    _vm.post.quote_text,
                                    160,
                                    "..."
                                  )
                                ) +
                                "\n              "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "w-100 pb6 flex flex-column z-content" }, [
              _c("div", { staticClass: "relative bg-teal pv5 relative" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-column container-fluid relative z-4",
                  },
                  [
                    _c(
                      "h2",
                      {
                        staticClass:
                          "f3 is-white center tc ttn lh-copy is-tablet-bold pv4 dib",
                        attrs: { id: "outside-lands-app" },
                      },
                      [
                        _vm._v(
                          "\n              We’ll send you the latest.\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("signup-form", {
                      staticClass: "w-100 mw6 dib form-is-blue",
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "dn db-ns absolute bottom-0 right-0 mr3 mb3" },
                  [
                    _c("img", {
                      staticClass: "mw4",
                      attrs: {
                        src: "/assets/images/bg-icons/ol20-hand-white.svg",
                      },
                    }),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }